/**
 * Import the React library and the NotificationComponent from the "./notificationComponent" file.
 * @module
 * @requires React
 * @requires NotificationComponent
 */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NotificationComponent from "./notificationComponent";

import useWindowDimension from "../../components/hooks/useWindowDimension";

import * as notificationItem from "../../api/notification.json";
import { notificationList } from "../../store/features/notification/notificationSlice";
import { showToast } from "../../store/features/toast/toastSlice";
import { getCloudinaryMediaBaseUrl } from "../../config/cloudinaryBase";

const NotificationContainer = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const dimensions = useWindowDimension();
  const data = useSelector((state) => state?.notification?.notification);
  const [read, setRead] = useState(false);
  const [placeholder, setPlaceholder] = useState(true);
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");

  /**
   * Constructs the Cloudinary URL by concatenating the environment variables
   * for the Cloudinary URL, name, and subfolder.
   * @returns The constructed Cloudinary URL.
   */
  const CLOUDINARY_URL = getCloudinaryMediaBaseUrl();

  useEffect(() => {
    setHeaderHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
  }, []);

  /**
   * useEffect hook that sets a placeholder value to false after a delay of 5000 milliseconds.
   * @param {{function}} callback - The callback function to be executed after the delay.
   * @param {{Array}} dependencies - An array of dependencies that trigger the effect when changed.
   * @returns None
   */
  useEffect(() => {
    const categoryData = notificationItem;
    dispatch(notificationList(categoryData?.data));
    setTimeout(() => {
      setPlaceholder(false);
    }, 2000);
  });
  const onReadClick = () => {
    setTimeout(() => {
      dispatch(
        showToast({
          message: t("ALL_NOTIFICATIONS_MARKED_AS_READ"),
          type: "success",
          show: false,
        })
      );
      setRead(true);
    }, 1000);
  };
  return (
    <NotificationComponent
      read={read}
      placeholder={placeholder}
      notificationMap={data}
      onReadClick={onReadClick}
      dimensions={dimensions}
      headerHeight={headerHeight}
      breadcrumbHeight={breadcrumbHeight}
      emptyImg={CLOUDINARY_URL + "notification.png"}
    />
  );
};

export default NotificationContainer;
